<script>
import { Bar } from 'vue-chartjs';

export default {
  extends: Bar,
  mounted() {
    // Overwriting base render method with actual data.
    this.renderChart({
      labels: ['فروردین',
        'اردیبهشت',
        'خرداد',
        'مهر',
        'آبان',
        'آذر',
        'دی',
        'بهمن',
        'اسفند'],
      datasets: [
        {
          defaultFontFamily: 'Vazir FD',
          label: 'میزان فروش',
          backgroundColor: '#ffffff',
          borderColor: '#ffffff',
          borderWidth: 0,
          borderRadius: 400,
          data: [100, 217, 126, 240, 56, 34, 619, 85, 298],
        },
        {
          defaultFontFamily: 'Vazir FD',
          label: 'میزان سود',
          backgroundColor: '#f0f0f0',
          borderColor: '#f0f0f0',
          borderWidth: 0,
          barRadius: 400,
          data: [170, 237, 146, 241, 96, 34, 69, 283, 129],
        },
      ],
    }, {
      defaultFontFamily: 'Vazir FD',
      responsive: true,
      maintainAspectRatio: false,
      aspectRatio: 1,
      scales: {
        xAxes: [{
          gridLines: {
            color: 'rgba(0, 0, 0, 0)',
            fontFamily: 'Vazir FD',
            drawBorder: false,
            zeroLineColor: '#ffcc3300',
          },
          ticks: {
            display: true,
            fontFamily: 'Vazir FD',
            color: '#fff',
            fontSize: 10,
          },
        }],
        yAxes: [
          {
            gridLines: {
              drawBorder: true,
              zeroLineColor: '#ffffff',
              fontFamily: 'Vazir FD',
              color: '#ffffff00',
            },
            ticks: {
              fontFamily: 'Vazir FD',
              fontSize: 16,
              fontColor: '#ffffff',
              color: '#ffffff',
              display: false,
            },
          }],
      },
      layout: {
        padding: 16,
      },
      legend: {
        display: false,
      },
    });
  },
};
</script>

<style lang="scss" scoped>
canvas {
  height: 250px !important;
}
</style>
